<template>
  <div align="center" style="overflow-x: scroll;">
 
    <h3>AS Plant</h3>
    <br />
    <!-- <vs-button
      color="primary"
      @click="tableToExcel('testTable', 'W3C Example Table')"
      type="filled"
      >Primary</vs-button
    > -->

  
    <table id="testTable" 
      summary="Code page support in different versions of MS Windows."
      rules="groups"
      frame="hsides"
      border="2">
	<tbody   >
		<tr>
			<td align="center" style="color: red; font-weight: 600; border: 1px solid #111111;" colspan="10"> Monthly Report of AS Wastewater Treatment Plant in 2021</td>
		</tr>
		<tr >
			<td align="center"  style="color: red; font-weight: 600; border: 1px solid #111111;"  rowspan="2">Plant</td>
			<td align="center" style="color: red; background-color: #00B050;font-weight: 600;border: 1px solid #111111;" colspan="4">Quantity in Used</td>
			<td align="center" style="color: red; background-color: rgb(218,150,148);font-weight: 600;border: 1px solid #111111;"  colspan="3">Cost in Used</td>
			<td align="center" style="color: red; background-color: #92CDDC;font-weight: 600;border: 1px solid #111111;"  colspan="2" rowspan="2">Compare cost</td>
		</tr>
		<tr>
			<td align="center" style="font-weight: 600;border: 1px solid #111111;" colspan="4">Quantity</td>
			<td align="center" style="color: red; background-color: #FFFF00;font-weight: 600;border: 1px solid #111111;"  colspan="3">Cost</td>
		</tr>
		<tr>
			<td align="center" style="color: #FFF; background-color: #7030A0;font-weight: 600;border: 1px solid #111111;">AS</td>
			<td align="center" style="color: #FFF; background-color: #7030A0;font-weight: 600;border: 1px solid #111111;" colspan="2">Water</td>
			<td align="center" style="color: #FFF; background-color: #7030A0;font-weight: 600;border: 1px solid #111111;">Electricity</td>
			<td align="center" style="color: #FFF; background-color: #663300;font-weight: 600;border: 1px solid #111111;">sludge</td>
			<td align="center" style="color: #FFF; background-color: #7030A0;font-weight: 600;border: 1px solid #111111;">Cost of Electricity</td>
			<td align="center" style="color: #FFF; background-color: #663300;font-weight: 600;border: 1px solid #111111;">Cost of sludge</td>
			<td style="background-color: #FFFF00;font-weight: 600;border: 1px solid #111111;">Total cost</td>
			<td align="center" style="color: #FFF; background-color: #7030A0;font-weight: 600;border: 1px solid #111111;">Cost of Chem./motorcycle</td>
			<td align="center" style="color: #FFF; background-color: #7030A0;font-weight: 600;border: 1px solid #111111;">ค่าบำบัดน้ำ/m3 </td>
		</tr>
    <tr>
			<td align="center" style="border: 1px solid #111111;  background-color: #B1A0C7;">หน่วย</td>
			<td align="center" style="border: 1px solid #111111;  background-color: #B1A0C7;" >Toilet (m3) (ENV-AS-11)</td>
      	<td align="center" style="border: 1px solid #111111;  background-color: #B1A0C7;" >Treat in AS (m3)</td>
			<td align="center" style="border: 1px solid #111111;  background-color: #B1A0C7;">(Unit)</td>
			<td align="center" style="border: 1px solid #111111;  background-color: #663300;">(Big bags)</td>
			<td align="center" style="border: 1px solid #111111;  background-color: #B1A0C7;">Bath.</td>
			<td align="center" style="border: 1px solid #111111;  background-color: #663300;">Bath.</td>
			<td align="center" style="border: 1px solid #111111; background-color: #FFFF00;">Bath.</td>
			<td align="center" style="border: 1px solid #111111;  background-color: #B1A0C7;">Bath./Unit</td>
			<td align="center" style="border: 1px solid #111111;  background-color: #B1A0C7;">Bath/m3</td>
		</tr>
		<tr v-for="i in items" :key="i" align="center">
			<td  >{{i.first_name}}</td>
			<td style="border: 1px solid #111111;  background-color: red;">{{i.water_toilet}}</td>
			<td style="border: 1px solid #111111;  background-color: red;">{{i.water_treat}}</td>
			<td style="border: 1px solid #111111;  background-color: red;">{{i.electricity}}</td>
		  <td style="border: 1px solid #111111;  background-color: #663300;"></td>
			<td></td>
			<td style="border: 1px solid #111111;  background-color: #663300;"></td>
			<td style="border: 1px solid #111111;  background-color: #FFFF00;"></td>
			<td></td>
			<td></td>
		</tr>	
    	<tr>
			<td align="center" style="color: #FFF; background-color: #7030A0 ;font-weight: 600;">TOTAL</td>
			<td align="center" style="color: #FFF; background-color: #7030A0 ;font-weight: 600;">{{total_water_toilet}}</td>
			<td align="center" style="color: #FFF; background-color: #7030A0 ;font-weight: 600;">{{total_water_treat}}</td>
			<td align="center" style="color: #FFF; background-color: #7030A0 ;font-weight: 600;">{{total_electricity}}</td>
			<td align="center" style="color: #FFF; background-color: #7030A0 ;font-weight: 600;"></td>
			<td align="center" style="color: #FFF; background-color: #7030A0 ;font-weight: 600;"></td>
			<td align="center" style="color: #FFF; background-color: #7030A0 ;font-weight: 600;"></td>
			<td align="center" style="color: #FFF; background-color: #7030A0 ;font-weight: 600;"></td>
			<td align="center" style="color: #FFF; background-color: #7030A0 ;font-weight: 600;"></td>
			<td align="center" style="color: #FFF; background-color: #7030A0 ;font-weight: 600;"></td>
		</tr>
    	<tr >
			<td style="color: #FFF; background-color: #7030A0 ;font-weight: 600;">AVERAGE</td>
			<td align="center" style="color: #FFF; background-color: #7030A0 ;font-weight: 600;">{{avg_water_toilet}}</td>
			<td align="center" style="color: #FFF; background-color: #7030A0 ;font-weight: 600;">{{avg_water_treat}}</td>
			<td align="center" style="color: #FFF; background-color: #7030A0 ;font-weight: 600;">{{avg_electricity}}</td>
			<td align="center" style="color: #FFF; background-color: #7030A0 ;font-weight: 600;"></td>
			<td align="center" style="color: #FFF; background-color: #7030A0 ;font-weight: 600;"></td>
		  <td align="center" style="color: #FFF; background-color: #7030A0 ;font-weight: 600;"></td>
			<td align="center" style="color: #FFF; background-color: #7030A0 ;font-weight: 600;"></td>
			<td align="center" style="color: #FFF; background-color: #7030A0 ;font-weight: 600;"></td>
			<td align="center" style="color: #FFF; background-color: #7030A0 ;font-weight: 600;"></td>
		</tr>
    </tbody>
</table><br>
 <h3>RO Plant</h3>
    <br />
 <table id="testTable2" 
      summary="Code page support in different versions of MS Windows."
      rules="groups"
      frame="hsides"
      border="2">
	<tbody>
		<tr>
			<td align="center" style="color: red; font-weight: 600; border: 1px solid #111111;" colspan="26">Monthly Report of RO Recycle Plant in 2021</td>
		</tr>
		<tr>
			<td align="center"  style="color: red; font-weight: 600; border: 1px solid #111111;"  rowspan="2">Plant</td>
			<td colspan="16">Quantity in Used</td>
			<td colspan="7">Cost in Used</td>
			<td colspan="2" rowspan="2">Compare cost</td>
		</tr>
		<tr>
			<td colspan="3">RO Water</td>
			<td colspan="12">Quantity</td>
			<td colspan="8">Cost</td>
		</tr>
		<tr>
			<td>RO Recycle</td>
			<td>RO Water</td>
			<td>Brine Water</td>
			<td>Electricity</td>
			<td colspan="2">Antiscale (N-900)</td>
			<td colspan="2">Biocide (IK-110)</td>
			<td colspan="2">SBS (Na2S2O5)</td>
			<td colspan="2">NaOCl</td>
			<td colspan="2">NaOH 0.1%</td>
			<td colspan="2">Citric Acid 2%</td>
			<td >Cost of Electricity</td>
			<td>Cost of Antiscale</td>
			<td>Cost of Biocide</td>
			<td>Cost of SBS</td>
			<td>Cost of NaOCl</td>
			<td>Cost of NaOH</td>
			<td>Cost of Citric Acid</td>
			<td>Total Cost of Chem.</td>
			<td >Cost of Chem./motorcycle</td>
			<td >ค่าบำบัดน้ำ/m3 </td>
		</tr>
		<tr>
			<td>หน่วย</td>
			<td>(m3)</td>
			<td>(m3)</td>
			<td>(Unit)</td>
			<td>L</td>
			<td>kg.</td>
			<td>L</td>
			<td>kg.</td>
			<td>L</td>
			<td>kg.</td>
			<td>L</td>
			<td>kg.</td>
			<td>NaOH 0.1% (L.)</td>
			<td>NaOH 50% (kg.)</td>
			<td>Citric Acid 2% (L.)</td>
			<td>Citric Acid 100% (kg.)</td>
			<td>Bath.</td>
			<td>Bath.</td>
			<td>Bath.</td>
			<td>Bath.</td>
			<td>Bath.</td>
			<td>Bath.</td>
			<td>Bath.</td>
			<td>Bath.</td>
			<td>Bath./Unit</td>
			<td>Bath/m3</td>
		</tr>
	
		<tr v-for="i in items" :key="i" align="center">
			<td  >{{i.first_name}}</td>
			<td >{{i.water_toilet}}</td>
			<td>{{i.water_toilet}}</td>
			<td >{{i.water_treat}}</td>
			<td >{{i.electricity}}</td>
			<td >{{i.water_treat}}</td>
			<td >{{i.electricity}}</td>
			<td >{{i.water_treat}}</td>
			<td >{{i.electricity}}</td>
			<td >{{i.water_treat}}</td>
			<td >{{i.electricity}}</td>
			<td >{{i.water_treat}}</td>
			<td >{{i.electricity}}</td>
			<td >{{i.water_treat}}</td>
			<td >{{i.electricity}}</td>
			<td >{{i.water_treat}}</td>
			<td></td>
			<td></td>
			<td></td>
			<td></td>
			<td></td>
			<td></td>
			<td></td>
			<td></td>
			<td></td>
			<td></td>
		</tr>
		<tr>
			<td>TOTAL</td>
			<td  >{{total_water_toilet}}</td>
			<td>{{total_water_toilet}}</td>
			<td  >{{total_water_treat}}</td>
			<td  >{{total_electricity}}</td>
			<td></td>
			<td></td>
			<td></td>
			<td></td>
			<td></td>
			<td></td>
			<td></td>
			<td></td>
			<td></td>
			<td></td>
			<td></td>
			<td></td>
			<td></td>
			<td></td>
			<td></td>
			<td></td>
			<td></td>
			<td></td>
			<td></td>
			<td></td>
			<td></td>
		</tr>
		<tr>
			<td>AVERAGE</td>
			<td  >{{avg_water_toilet}}</td>
			<td>{{avg_water_toilet}}</td>
			<td  >{{avg_water_treat}}</td>
			<td  >{{avg_electricity}}</td>
			<td></td>
			<td></td>
			<td></td>
			<td></td>
			<td></td>
			<td></td>
			<td></td>
			<td></td>
			<td></td>
			<td></td>
			<td></td>
			<td></td>
			<td></td>
			<td></td>
			<td></td>
			<td></td>
			<td></td>
			<td></td>
			<td></td>
			<td></td>
			<td></td>
		</tr>
	</tbody>
</table>
<br>
 <h3>Recycle  Plant</h3>
    <br />
<table id="testTable3" 
      summary="Code page support in different versions of MS Windows."
      rules="groups"
      frame="hsides"
      border="2">
	<tbody>
		<tr align="center">
			<td colspan="13">Monthly Report of Recycle Water Plant in 2021</td>
		</tr>
		<tr align="center">
			<td rowspan="2">Plant</td>
			<td colspan="7">Quantity in Used</td>
			<td colspan="3">Cost in Used</td>
			<td colspan="2" rowspan="2">Compare cost</td>
		</tr>
		<tr align="center">
			<td colspan="3">Quantity of Water</td>
			<td colspan="2">Quantity of Electricity</td>
			<td colspan="2">Quantity of Chemical</td>
			<td colspan="3">Cost of Chemical</td>
		</tr>
		<tr align="center">
			<td>RECYCLE</td>
			<td>Recycle Water</td>
			<td>Brine Water</td>
			<td>City Water</td>
			<td colspan="2">Electricity</td>
			<td colspan="2">NaOCl</td>
			<td>Cost of Electricity</td>
			<td>Cost of NaOCl</td>
			<td>Total cost</td>
			<td>Cost of Chem./motorcycle</td>
			<td>ค่าบำบัดน้ำ/m3 </td>
		</tr>
		<tr v-for="i in items" :key="i" align="center">
			<td  >{{i.first_name}}</td>
			<td >{{i.water_toilet}}</td>
			<td >{{i.water_toilet}}</td>
			<td>{{i.water_toilet}}</td>
			<td >{{i.water_toilet}}</td>
			<td >{{i.water_toilet}}</td>
			<td>{{i.water_toilet}}</td>
			<td>{{i.water_toilet}}</td>
			<td></td>
			<td></td>
			<td></td>
			<td></td>
			<td></td>
		</tr>
		<tr  align="center">
			<td>TOTAL</td>
			<td  >{{total_water_toilet}}</td>
			<td>{{total_water_toilet}}</td>
			<td  >{{total_water_treat}}</td>
			<td  >{{total_electricity}}</td>
			<td>{{total_water_toilet}}</td>
			<td  >{{total_water_treat}}</td>
			<td  >{{total_electricity}}</td>
			<td></td>
			<td></td>
			<td></td>
			<td></td>
			<td></td>
		</tr>
		<tr  align="center">
			<td>AVERAGE</td>
			<td  >{{avg_water_toilet}}</td>
			<td>{{avg_water_toilet}}</td>
			<td  >{{avg_water_treat}}</td>
			<td  >{{avg_electricity}}</td>
			<td>{{avg_water_toilet}}</td>
			<td  >{{avg_water_treat}}</td>
			<td  >{{avg_electricity}}</td>
			<td></td>
			<td></td>
			<td></td>
			<td></td>
			<td></td>
		</tr>
	</tbody>
</table>
    <vs-row
      class="mt-4"
      vs-align="flex-start"
      vs-type="flex"
      vs-justify="center"
      vs-w="12"
    >
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
        <vs-button
          color="success"
          class="btnSub"
          @click="tableToExcel('testTable','testTable2','testTable3', 'W3C Example Table')"
          type="filled"
          >Download</vs-button
        >
		  <vs-button
          color="success"
          class="btnSub"
          @click="tableToExcel2('testTable', 'W3C Example Table')"
          type="filled"
          >Download</vs-button
        >
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import * as XLSX from "xlsx";
export default {
   props: { select_duration: String,select_plan:String ,total_water_toilet: Number,
    total_water_treat: Number,
    total_electricity: Number,
    avg_water_toilet: Number,
    avg_water_treat: Number,
    avg_electricity: Number,items: Array},
  data: () => ({
    table: "testTable",
    name: "W3C Example Table",
    data_sensor: [], 
    items: [],
    
    
  }),
  methods: {
    tableToExcel(table1,table2,table3, name1) {
      console.log(table1 + name1);
	    let targetTableElm1 = document.getElementById(table1);
		let targetTableElm2 = document.getElementById(table2);
		let targetTableElm3 = document.getElementById(table3);

		const wb = { SheetNames: [], Sheets: {} };
		var ws1 = XLSX.utils.table_to_book(targetTableElm1).Sheets.Sheet1;
		
		wb.SheetNames.push("AS");
		wb.Sheets["AS"] = ws1;
		// wb.Sheets["AS"]['A1'] = {
		// 		"v": "Red",
		// 		"s": {
		// 			"fill": {
		// 				"bgColor": {
		// 					"rgb":"FFFFAA00"
		// 				}
		// 			}
		// 		},
		// 		"t": "s"
		// 	}
        
		var ws2 = XLSX.utils.table_to_book(targetTableElm2).Sheets.Sheet1;
		wb.SheetNames.push("RO"); wb.Sheets["RO"] = ws2;
		var ws3 = XLSX.utils.table_to_book(targetTableElm3).Sheets.Sheet1;
		wb.SheetNames.push("Recycle"); wb.Sheets["Recycle"] = ws3;

		const blob = new Blob([this.s2ab(XLSX.write(wb, { bookType: 'xlsx', type: 'binary' }))], {
		type: "application/octet-stream"
		});
		const link = document.createElement('a');
		link.href = window.URL.createObjectURL(blob);
		link.download = 'Data wastewater chemical electricity in Env control section.xlsx';

		document.body.appendChild(link);

		link.click();

		document.body.removeChild(link);
    },
	  tableToExcel2(table1, name1) {
      console.log(table1 + name1);
      var uri = "data:application/vnd.ms-excel;base64,",
	   template =
          '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet><x:ExcelWorksheet><x:Name>{worksheet_2}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
        
        template2 =
          '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet_2}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table_2}</table></body></html>',
        base64 = function (s) {
          return window.btoa(unescape(encodeURIComponent(s)));
        },
        format = function (s, c) {
          return s.replace(/{(\w+)}/g, function (m, p) {
            return c[p];
          });
        };
     table1 = document.getElementById(table1);
      var ctx = {worksheet: "111" || "Worksheet", table: table1.innerHTML }
      var ctx2 = { worksheet_2: "1111s" || "Worksheet", table_2: table1.innerHTML };
      window.location.href = uri + [base64(format(template,template,ctx,ctx2))];
      return window.location.href;
    },
	s2ab(s) {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
    return buf;
  }
    // tableToExcel(table1,table2, name1) {
    //   console.log(table1 + name1);
    //   var worksheetsXML =""
    //   var uri = "data:application/vnd.ms-excel;base64,",
    //     template =
    //       '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetSource HRef="#t1"/><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet><x:ExcelWorksheet><x:Name>{worksheet_2}</x:Name><x:WorksheetSource HRef="#t2"/><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table id="t2">{table}</table><table id="t1">{table_2}</table></body></html>',
    //     base64 = function (s) {
    //       return window.btoa(unescape(encodeURIComponent(s)));
    //     },
    //     format = function (s, c) {
    //       return s.replace(/{(\w+)}/g, function (m, p) {
    //         return c[p];
    //       });
    //     };
        
    //   if (!table1.nodeType) table1 = document.getElementById(table1);
    //   if (!table2.nodeType) table2 = document.getElementById(table2);
    //   var ctx = { worksheet: "aaaaaaaa" || "Worksheet", worksheet_2: "ssss" || "Worksheet", table: table1.innerHTML , table_2: table1.innerHTML };
    //    var ctx2 = { worksheet: "aaaaaaaa" || "Worksheet", worksheet_2: "ssss" || "Worksheet", table: table1.innerHTML , table_2: table1.innerHTML };
   
    //   console.log("ctx", format(template, ctx));
    //   window.location.href = uri + base64(format(template, ctx)+format(template, ctx2));
      
    //   return window.location.href;
    // },
    // tableToExcel(table1, name1) {
    //   console.log(table1 + name1);
    //   var sheet = ''
    //   var book = ''
    //   var uri = "data:application/vnd.ms-excel;base64,",
    //     template =
    //       '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
    //     base64 = function (s) {
    //       return window.btoa(unescape(encodeURIComponent(s)));
    //     },
    //     format = function (s, c) {
    //       return s.replace(/{(\w+)}/g, function (m, p) {
    //         return c[p];
    //       });
    //     };
    //   if (!table1.nodeType) table1 = document.getElementById(table1);
    //   var ctx = { worksheet: name1 || "Worksheet", table: table1.innerHTML };
    //   sheet += format(template, ctx)
    //   sheet += format(template, ctx)
      
    //   ctx = {created: (new Date()).getTime(),worksheets: sheet};
    //   book = format(template, ctx);

    //   window.location.href = uri + base64(book);
    //   return window.location.href;
    // },
  },
  mounted() {
    //  let arr_water_toilet = [];
    //  let arr_water_treat = [];
    //  let arr_electricity = [];
    // this.$API.get("yamaha/dashboard/aluminium").then((result) => {
    //   this.data_sensor = result.data;
    // });
    // this.items.forEach((item) =>{
    //   item.electricity = item.water_toilet+item.water_treat
    //   this.total_water_toilet +=  item.water_toilet
    //   this.total_water_treat +=  item.water_treat
    //   this.total_electricity  += item.electricity
    //   arr_water_toilet.push(item.water_toilet)
    //   arr_water_treat.push(item.water_treat)
    //   arr_electricity.push(item.electricity)
    //   this.avg_water_toilet =  (this.total_water_toilet/arr_water_toilet.length).toFixed(2);;
    //   this.avg_water_treat =  (this.total_water_treat/arr_water_treat.length).toFixed(2);;
    //   this.avg_electricity  = (this.total_electricity/arr_electricity.length).toFixed(2);;
    // })
    console.log(this.select_duration);
    
  },
};
</script>

<style scoped>
table , td, th {
	border: 1px solid #111111;
	border-collapse: collapse;
  font-size: 15px;
  
}
/* td, th {
	padding: 3px;
	width: 30px;
	height: 25px;
} */
th {
	background: #f0e6cc;
}
.even {
	background: #fbf8f0;
}
.odd {
	background: #fefcf9;
}
.btnSub {
  width: 100px;
  border-radius: 20px;
}
.cardRadi {
  border-radius: 20px;
}
</style>